import {client} from "@/api/client";

export default {
    async createAlbum(detailAlbum) {
        return await client.post("/albums", detailAlbum);
    },
    async getDetailAlbum(id) {
        return await client.get(`/albums/${id}/detail`);
    },
    async getAlbumList({page, size, qType, q, sort, statusFilter}) {
        return await client.get("/albums", {
            params: {
                page,
                size,
                qType,
                q,
                sort,
                statusFilter,
            }
        });
    },
    async getMyAlbumList({page, size, sort, statusFilter}) {
        return await client.get("/albums/my", {
            params: {
                page,
                size,
                sort,
                statusFilter,
            }
        });
    }
}